import React from 'react';
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

import css from './TitleMenuDishes.module.css';
import {getTitleMenuDishes} from "../../../helpers";


const TitleMenuDishes = () => {
    const {t} = useTranslation();
    const listTitleMenu = getTitleMenuDishes(t);


    return (
        <nav className={css.wrap}>
            <ul className={css.ul}>
                {listTitleMenu.map(({name, linkForRoute}) => (
                    <li key={name}>
                        <NavLink
                            to={`/dishes/${linkForRoute.toLowerCase()}`}
                            className={({isActive}) =>
                                `${css.menuItem} ${isActive ? css.active : ''}`
                            }
                        >
                            <span className={css.menuText}>{name}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export {TitleMenuDishes};